module.exports = __webpack_public_path__ + "static/media/Facebook.df65b6c0.svg";